import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const smartAppBannerStyles = (theme: Theme) => ({
	root: {
		display: 'flex',
		color: 'white',
		alignItems: 'center',
		padding: '8px 10px',
		gap: '8px',
		minHeight: '52px',
		position: 'relative',
		zIndex: 100,
		backgroundColor: 'rgba(0, 0, 0, 1)',
	},
	info: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		gap: '4px',
	},
	title: {
		color: 'white',
		fontWeight: 600,
		fontSize: '14px',
		lineHeight: '17.36px',
		fontFamily: 'Montserrat',
		userSelect: 'none',
	},
	description: {
		color: '#C5C5C5',
		fontSize: '13px',
		lineHeight: '13px',
		fontFamily: 'Hind',
		userSelect: 'none',
	},
	button: {
		color: 'white',
		p: '6px 12px',
		fontSize: '13px',
		fontWeight: 700,
		lineHeight: '15.6px',
		fontFamily: 'Montserrat',
		textTransform: 'none',

		cursor: 'pointer',
		userSelect: 'none',

		borderRadius: '100px',
		border: `1px solid ${Colors.white_a10}`,
		background: Colors.gray_a70,
	},
});
